// @flow

function getParameterByName(name) {
    const match = RegExp(`[?&]${name}=([^&]*)`).exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

const getCustUrl = () => {
    if (process.env.CRAWL_USERNAME) {
        return process.env.CRAWL_USERNAME;
    }

    const custParam = getParameterByName("go");
    if (custParam) {
        return custParam;
    }
    const params = window.location.pathname.split("/");
    return params.length < 2 ? null : params[1];
};

export { getCustUrl };



// WEBPACK FOOTER //
// ./src/utils/cust.js